// extracted by mini-css-extract-plugin
export default {"mainContent":"ModalCalcMemory_mainContent__t2N7L","input":"ModalCalcMemory_input__Rc8AH","footer":"ModalCalcMemory_footer__R6qy-"};